/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Pridať k objednávke",
  "i18n.additionalProducts.emotionalHook": "♥️ Veľmi obľúbený:",
  "i18n.additionalProducts.productDescription": "Popis produktu",
  "i18n.additionalProducts.showMore": "Viac informácií",
  "i18n.additionalProducts.title": "Vhodné príslušenstvo",
  "i18n.button.addToCart": "Vložiť do nákupného košíka",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Pokračovať",
  "i18n.button.back": "Späť",
  "i18n.button.cancel": "Storno",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Zatvoriť",
  "i18n.button.continue": "Pokračovať",
  "i18n.button.ignore": "Ignorovať",
  "i18n.button.ignoreAndContinue": "Pokračovať",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Bez SMART SORTED",
  "i18n.button.design": "",
  "i18n.button.photos": "Fotografie",
  "i18n.button.retry": "Opakovať",
  "i18n.button.uploadPhotos": "Nahrať fotku(y)",
  "i18n.button.withSmartSorted": "SMART SORTED",
  "i18n.button.withoutSmartSorted": "Bez SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pre lepšiu čitateľnosť upravte, prosím, dĺžku textu",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Vybraný štýl písma je pre tento text moc dlhý.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Maximálna veľkosť písma pre tento štýl bola prekročená.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Minimálna veľkosť písma pre tento štýl bola dosiahnutá.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Prosím vložte zalomenia textu",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Pokračujte v písaní na ďalší riadek alebo zväčšite textové pole.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Skontrolujte zadaný text. Toto písmo nepodporuje všetky znaky.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Pre lepšiu čitateľnosť upravte dĺžku textu.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "prosím zväčšite textové pole",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Tento krok sa nedá urobiť spätne",
  "i18n.dialog.deletePlaceholder.title": "Naozaj zmazať?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Rozlíšenie tejto fotografie je príliš nízke na to, aby sa fotografia vytlačila ostrá a detailná!",
  "i18n.dialog.smartSorted.message": "So SMART SORTED môžete inovatívne a bez námahy zostaviť 1000-dielne motívy aj bez predlohy",
  "i18n.dialog.smartSorted.title": "Úspech puzzle zaručený",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Pre zmenu textu kliknite na \"{{text}}\".",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Text na škatuľke nebol zmenený",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Pokračovať bez textu",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Fotografiu vložíte kliknutím na symbol obrázku",
    "Fotografie vložíte kliknutím na symboly obrázku",
    "Fotografie vložíte kliknutím na symboly obrázku"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Nebola vložená jedna fotografie",
    "Nebolo vložené viac fotografií",
    "Nebolo vložené viac fotografií"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Zostáva nahrať jednu fotografiu.",
    "Zostáva nahrať viac fotografií.",
    "Zostáva nahrať viac fotografií."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Pre zmenu textu kliknite prosím na kolónku s textom",
    "Pre zmenu textov kliknite prosím na kolónky s textom",
    "Pre zmenu textov kliknite prosím na kolónky s textom"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Kolónka s textom nebola zmenená",
    "Kolónky s textami neboli zmenené",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Nebolo nahrané viac fotografií",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Na návrhu ste dlho nepracovali, takže nemôže byť dokončený. Začnite prosím od začiatku.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Fotka nebola nahraná. Bola odstránená z galérie a plochy",
  "i18n.error.imageLoadingError.title": "Chyba nahrávania",
  "i18n.error.imageProvisionError.message": "Jedna alebo viac fotiek neboli nahrané, zrejme sú v nepodporovanom formáte.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Súbor \"{{reference1}}\" nemohl byť spracovaný.",
  "i18n.error.imageSelectionError.title": "Chyba nahrávania fotky",
  "i18n.error.imageSizeLimitExceededError.message": "Nahraný obrázok je príliš veľký.\nZmenšite ho prosím na menej ako 180 megapixelov a skúste ho nahrať znova.",
  "i18n.error.imageSizeLimitExceededError.title": "Chyba nahrávania fotky",
  "i18n.error.imageUploadError.message": "Vyskytol sa problém s internetovým pripojením. Skúste to znova neskôr.",
  "i18n.error.imageUploadError.title": "Chyba nahrávania fotky",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Tento typ písma nemožno použiť, vyberte prosím iný",
  "i18n.error.invalidCharConfigError.title": "Typ pisma nie je použiteľné",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Zrejme došlo k prerušeniu internetového pripojenia. Na vytváranie produktu sa môžete vrátiť hneď ako dôjde k obnoveniu pripojenia.",
  "i18n.error.templateLoadingError.message": "Šablóna \"{{ error.reference[0] }}\" nebola nahraná.\nSkúste to znova neskôr.",
  "i18n.error.templateLoadingError.title": "Chyba nahrávania",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" je v nepodporovanom formáte.",
  "i18n.error.unsupportedMediaTypeError.title": "Chyba počas nahrávania fotografií",
  "i18n.error.uploadProductError.message": "Jeden alebo niekoľko produktov nebolo prenesené na server.\nProsím skúste to znova neskôr.",
  "i18n.error.uploadProductError.title": "Chyba prenosu",
  "i18n.error.zoomModeError.message": "Váš text z predchádzajúceho návrhu nie je možné prevziať. Zadajte prosím nový text.",
  "i18n.error.zoomModeError.title": "Text nebol prijatý",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Cena",
  "i18n.price.reduction": "Ušetríte",
  "i18n.price.total": "Celková cena",
  "i18n.priceDisplay.times": [
    "{{value}} kus každý za {{pricePerUnit}}",
    "{{value}} kusy každý za {{pricePerUnit}}",
    "{{value}} kusov každý za {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Vybrať doplnky",
  "i18n.progressOverlay.message.lines.one": "Ďakujeme za vytvorenie tohto pekného výrobku.",
  "i18n.progressOverlay.message.lines.two": "Všetko pre Vás pripravíme...",
  "i18n.template.insertText": "Zde zadajte text",
  "i18n.toolbox.image.title": "Upraviť fotku",
  "i18n.toolbox.layout.template.count": [
    "",
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 fotka",
    "{{value}} fotky",
    "{{value}} fotiek"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D náhľad",
  "i18n.toolbox.productChooser.title": "Zmena produktu",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Upraviť text",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleSkSK {
  public getPlural(n: number): number
  {
    const pluralForm = (n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
